// Vue 3 compatible wrappers for GTM directives
import {
  dataLayerAnchorTag,
  dataLayerButtonTag,
  dataLayerSelectTag,
  dataLayerInputTag,
} from 'data-layer-test-oo-gtm';

// Wrap Vue 2 directives to work with Vue 3
const wrapDirective = (vue2Directive) => {
  if (!vue2Directive) return null;

  return {
    mounted(el, binding, vnode) {
      // Call Vue 2 directive's bind hook if it exists
      if (vue2Directive.bind) {
        vue2Directive.bind(el, binding, vnode, null);
      }
      // Call Vue 2 directive's inserted hook if it exists
      if (vue2Directive.inserted) {
        vue2Directive.inserted(el, binding, vnode, null);
      }
    },
    updated(el, binding, vnode, prevVnode) {
      // Call Vue 2 directive's update hook if it exists
      if (vue2Directive.update) {
        vue2Directive.update(el, binding, vnode, prevVnode);
      }
      // Call Vue 2 directive's componentUpdated hook if it exists
      if (vue2Directive.componentUpdated) {
        vue2Directive.componentUpdated(el, binding, vnode, prevVnode);
      }
    },
    unmounted(el, binding, vnode) {
      // Call Vue 2 directive's unbind hook if it exists
      if (vue2Directive.unbind) {
        vue2Directive.unbind(el, binding, vnode);
      }
    },
  };
};

// Export wrapped directives
export const dataanchor = wrapDirective(dataLayerAnchorTag);
export const databutton = wrapDirective(dataLayerButtonTag);
export const dataselect = wrapDirective(dataLayerSelectTag);
export const datainput = wrapDirective(dataLayerInputTag);
